import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../../config/StateSchema";
import {BaseResponse} from "../../../../../api/api";
import {snackbarAction} from "../../../../errors/SnackbarSlice";
import {ICalendarResponse} from "../../../../scheduler/types/IScheduler";

interface IResponse {
    info: ICalendarResponse
}

export const fetchTwilioCallSchedule = createAsyncThunk<
    ICalendarResponse,
    string,
    ThunkConfig<string>
>(
    'twilioCalls/fetchTwilioCallSchedule',
    async (scheduleId, thunkAPI) => {
        const {extra, rejectWithValue, dispatch} = thunkAPI;
        try {
            const response = await extra.api.get<BaseResponse<IResponse>>(`schedule/${scheduleId}`)

            if (!response.data.success) {
                return rejectWithValue('error')
            }

            return response.data.response.info
        } catch (err) {
            dispatch(snackbarAction.addError('INTERNAL_ERROR'))
            return rejectWithValue('error');
        }
    },
);
